<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="">
      <div class="row">
        <label class="col-sm-2 col-form-label">트랜잭션 ID</label>
        <div class="col-sm-6">
          <base-input placeholder="transactionId" v-model="transactionId">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <div class="col-sm-4">
          <base-button @click="loadSubscriptionInfoByTransactionId" type="success">불러오기</base-button>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">PAYLOAD</label>
        <div class="col-sm-6">
          <base-input placeholder="payload" v-model="payload">
            <span slot="helpBlock" class="form-text" />
          </base-input>
        </div>
        <div class="col-sm-4">
          <base-button @click="loadSubscriptionInfoByPayload" type="success">불러오기</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <base-input placeholder="내용">
            <textarea class="form-control langData" rows="100" v-model="data" />
          </base-input>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseButton, BaseInput } from "@/components/index";

export default {
  components: {
    BaseInput,
    BaseButton,
  },
  async created() {},
  data() {
    return {
      transactionId: null,
      data: null,
      payload: null,
    };
  },
  methods: {
    async loadSubscriptionInfoByTransactionId() {
      if (!this.transactionId) {
        return;
      }

      return this.$axios.get(`/payments/transaction/${this.transactionId}`).then((res) => {
        this.data = JSON.stringify(res.data.data);
      });
    },
    async loadSubscriptionInfoByPayload() {
      if (!this.payload) {
        return;
      }
      const base64String = this.payload.split(".")[1];

      return this.$axios.post(`/payments/verifyReceipt`, { base64String }).then((res) => {
        this.data = JSON.stringify(res.data.data);
      });
    },
  },
};
</script>
<style>
textarea.langData {
  max-height: 500px;
}
</style>
